module.exports = "/paper_plain-e814cf7b4ef7d714bd29d788d2830c76.svg";